export interface TimezoneEntry {
    key: string;
    city: string;
    abbr: string;
    offset: number;
    region: string;
}

export const TIMEZONES: TimezoneEntry[] = [
    // Americas (alphabetical by city)
    { key: 'America/Anchorage', city: 'Anchorage', abbr: 'AKST', offset: -9, region: 'Americas' },
    { key: 'America/Bogota', city: 'Bogot\u00e1', abbr: 'COT', offset: -5, region: 'Americas' },
    {
        key: 'America/Argentina/Buenos_Aires',
        city: 'Buenos Aires',
        abbr: 'ART',
        offset: -3,
        region: 'Americas',
    },
    { key: 'America/Chicago', city: 'Chicago', abbr: 'CST', offset: -6, region: 'Americas' },
    { key: 'America/Denver', city: 'Denver', abbr: 'MST', offset: -7, region: 'Americas' },
    { key: 'America/Halifax', city: 'Halifax', abbr: 'AST', offset: -4, region: 'Americas' },
    { key: 'Pacific/Honolulu', city: 'Honolulu', abbr: 'HST', offset: -10, region: 'Americas' },
    { key: 'America/Lima', city: 'Lima', abbr: 'PET', offset: -5, region: 'Americas' },
    {
        key: 'America/Los_Angeles',
        city: 'Los Angeles',
        abbr: 'PST',
        offset: -8,
        region: 'Americas',
    },
    {
        key: 'America/Mexico_City',
        city: 'Mexico City',
        abbr: 'CST',
        offset: -6,
        region: 'Americas',
    },
    { key: 'America/New_York', city: 'New York', abbr: 'EST', offset: -5, region: 'Americas' },
    { key: 'America/Phoenix', city: 'Phoenix', abbr: 'MST', offset: -7, region: 'Americas' },
    { key: 'America/Santiago', city: 'Santiago', abbr: 'CLT', offset: -4, region: 'Americas' },
    {
        key: 'America/Sao_Paulo',
        city: 'S\u00e3o Paulo',
        abbr: 'BRT',
        offset: -3,
        region: 'Americas',
    },
    { key: 'America/Toronto', city: 'Toronto', abbr: 'EST', offset: -5, region: 'Americas' },
    { key: 'America/Vancouver', city: 'Vancouver', abbr: 'PST', offset: -8, region: 'Americas' },

    // Europe & Africa (alphabetical by city)
    { key: 'Africa/Accra', city: 'Accra', abbr: 'GMT', offset: 0, region: 'Europe & Africa' },
    {
        key: 'Europe/Amsterdam',
        city: 'Amsterdam',
        abbr: 'CET',
        offset: 1,
        region: 'Europe & Africa',
    },
    { key: 'Europe/Athens', city: 'Athens', abbr: 'EET', offset: 2, region: 'Europe & Africa' },
    { key: 'Europe/Berlin', city: 'Berlin', abbr: 'CET', offset: 1, region: 'Europe & Africa' },
    { key: 'Africa/Cairo', city: 'Cairo', abbr: 'EET', offset: 2, region: 'Europe & Africa' },
    { key: 'Europe/Helsinki', city: 'Helsinki', abbr: 'EET', offset: 2, region: 'Europe & Africa' },
    { key: 'Europe/Istanbul', city: 'Istanbul', abbr: 'TRT', offset: 3, region: 'Europe & Africa' },
    { key: 'Africa/Lagos', city: 'Lagos', abbr: 'WAT', offset: 1, region: 'Europe & Africa' },
    { key: 'Europe/Lisbon', city: 'Lisbon', abbr: 'WET', offset: 0, region: 'Europe & Africa' },
    { key: 'Europe/London', city: 'London', abbr: 'GMT', offset: 0, region: 'Europe & Africa' },
    { key: 'Europe/Madrid', city: 'Madrid', abbr: 'CET', offset: 1, region: 'Europe & Africa' },
    { key: 'Europe/Moscow', city: 'Moscow', abbr: 'MSK', offset: 3, region: 'Europe & Africa' },
    { key: 'Africa/Nairobi', city: 'Nairobi', abbr: 'EAT', offset: 3, region: 'Europe & Africa' },
    { key: 'Europe/Paris', city: 'Paris', abbr: 'CET', offset: 1, region: 'Europe & Africa' },
    { key: 'Europe/Rome', city: 'Rome', abbr: 'CET', offset: 1, region: 'Europe & Africa' },

    // Asia & Middle East (alphabetical by city)
    { key: 'Asia/Bangkok', city: 'Bangkok', abbr: 'ICT', offset: 7, region: 'Asia & Middle East' },
    { key: 'Asia/Dhaka', city: 'Dhaka', abbr: 'BST', offset: 6, region: 'Asia & Middle East' },
    { key: 'Asia/Dubai', city: 'Dubai', abbr: 'GST', offset: 4, region: 'Asia & Middle East' },
    {
        key: 'Asia/Hong_Kong',
        city: 'Hong Kong',
        abbr: 'HKT',
        offset: 8,
        region: 'Asia & Middle East',
    },
    { key: 'Asia/Jakarta', city: 'Jakarta', abbr: 'WIB', offset: 7, region: 'Asia & Middle East' },
    { key: 'Asia/Karachi', city: 'Karachi', abbr: 'PKT', offset: 5, region: 'Asia & Middle East' },
    {
        key: 'Asia/Kathmandu',
        city: 'Kathmandu',
        abbr: 'NPT',
        offset: 5.75,
        region: 'Asia & Middle East',
    },
    { key: 'Asia/Kolkata', city: 'Mumbai', abbr: 'IST', offset: 5.5, region: 'Asia & Middle East' },
    { key: 'Asia/Riyadh', city: 'Riyadh', abbr: 'AST', offset: 3, region: 'Asia & Middle East' },
    { key: 'Asia/Seoul', city: 'Seoul', abbr: 'KST', offset: 9, region: 'Asia & Middle East' },
    {
        key: 'Asia/Shanghai',
        city: 'Shanghai',
        abbr: 'CST',
        offset: 8,
        region: 'Asia & Middle East',
    },
    {
        key: 'Asia/Singapore',
        city: 'Singapore',
        abbr: 'SGT',
        offset: 8,
        region: 'Asia & Middle East',
    },
    { key: 'Asia/Taipei', city: 'Taipei', abbr: 'CST', offset: 8, region: 'Asia & Middle East' },
    { key: 'Asia/Tehran', city: 'Tehran', abbr: 'IRST', offset: 3.5, region: 'Asia & Middle East' },
    { key: 'Asia/Tokyo', city: 'Tokyo', abbr: 'JST', offset: 9, region: 'Asia & Middle East' },

    // Oceania & Pacific (alphabetical by city)
    {
        key: 'Australia/Adelaide',
        city: 'Adelaide',
        abbr: 'ACST',
        offset: 9.5,
        region: 'Oceania & Pacific',
    },
    {
        key: 'Pacific/Auckland',
        city: 'Auckland',
        abbr: 'NZST',
        offset: 12,
        region: 'Oceania & Pacific',
    },
    {
        key: 'Australia/Brisbane',
        city: 'Brisbane',
        abbr: 'AEST',
        offset: 10,
        region: 'Oceania & Pacific',
    },
    { key: 'Pacific/Fiji', city: 'Fiji', abbr: 'FJT', offset: 12, region: 'Oceania & Pacific' },
    {
        key: 'Australia/Melbourne',
        city: 'Melbourne',
        abbr: 'AEST',
        offset: 10,
        region: 'Oceania & Pacific',
    },
    { key: 'Australia/Perth', city: 'Perth', abbr: 'AWST', offset: 8, region: 'Oceania & Pacific' },
    {
        key: 'Australia/Sydney',
        city: 'Sydney',
        abbr: 'AEST',
        offset: 10,
        region: 'Oceania & Pacific',
    },
];

export const REGIONS = [
    'Americas',
    'Europe & Africa',
    'Asia & Middle East',
    'Oceania & Pacific',
] as const;

export function formatOffset(offset: number): string {
    const sign = offset >= 0 ? '+' : '\u2212';
    const hours = Math.floor(Math.abs(offset));
    const minutes = (Math.abs(offset) % 1) * 60;
    return `UTC ${sign}${hours}${minutes ? `:${String(minutes).padStart(2, '0')}` : ''}`;
}

export function getLiveTime(ianaKey: string): string {
    try {
        return new Date().toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZone: ianaKey,
        });
    } catch {
        // Fallback for unsupported IANA keys — compute from offset
        const tz = TIMEZONES.find((t) => t.key === ianaKey);
        if (!tz) return '';
        const now = new Date();
        const utc = now.getTime() + now.getTimezoneOffset() * 60000;
        const target = new Date(utc + tz.offset * 3600000);
        return target.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });
    }
}

export function getDayNightIndicator(ianaKey: string): string {
    try {
        const hour = parseInt(
            new Date().toLocaleTimeString('en-US', {
                hour: 'numeric',
                hour12: false,
                timeZone: ianaKey,
            }),
            10
        );
        return hour >= 6 && hour < 18 ? '☀️' : '🌙';
    } catch {
        return '';
    }
}

export function getDisplayText(tz: TimezoneEntry): string {
    return `${tz.city} (${tz.abbr})`;
}

export function getSearchText(tz: TimezoneEntry): string {
    return `${tz.city} ${tz.abbr} ${formatOffset(tz.offset)} ${tz.key}`;
}

export function detectTimezone(): string | null {
    try {
        const id = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return TIMEZONES.find((t) => t.key === id)?.key ?? null;
    } catch {
        return null;
    }
}
